
import {ElLoading, ElMessage, ElMessageBox} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
const columnList: Array<column> = [
    // {
    //     prop: "user_id",
    //     label: "会员号",
    //     width: 60,
    // },
    // {
    //     prop: "order_message_give_text",
    //     label: "送修人",
    //     width: 60,
    // },
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 60,
    },
    {
        prop: "order_crd_code_text",
        label: "车牌号",
        width: 70,
    },
    {
        prop: "order_crd_name_text",
        label: "品牌车型",
        width: 60,
    },
    {
        prop: "create_time",
        label: "开单时间",
        width: 75,
    },
    {
        prop: "settlementperson_text",
        label: "结算人",
        width: 60,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 75,
    },
    {
        prop: "settlement_status_text",
        label: "结算状态",
        width: 60,
    },
    {
        prop: "order_offer_price",
        label: "报价金额",
        width: 60,
    },
    {
        prop: "settlement_notes",
        label: "工单备注",
        width: 75,
    },
    {
        prop: "return_price",
        label: "待回款",
        width: 60,
    },
    {
        prop: "price",
        label: "结算金额",
        width: 60,
    },
    {
        prop: "settlement_type_text",
        label: "结算方式",
        width: 60,
    },
];

const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];
const settlementType:Array<any> = [
    {
        type_id:0,
        type_name:'A类',
        type_desc:'正常结算'
    },
    {
        type_id:1,
        type_name:'B1类',
        type_desc:'不结算，无代收款'
    }
];
const elseCostListColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "成本项目",
        width: 120,
    },
    {
        prop: "othercosts_costprice",
        label: "成本",
        width: 120,
    },
    {
        prop: "branch_name",
        label: "成本承担部门",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
];
const costRules = {
    othercosts_name: [
        {
            required: true,
            message: "请输入成本项目",
            trigger: "change",
        },
    ],
    othercosts_costprice: [
        {
            required: true,
            message: "请输入成本",
            trigger: "change",
        },
    ],
    branch_id: [
        {
            required: true,
            message: "请选择成本承担部门",
            trigger: "change",
        },
    ],
    // supplier_id: [
    //     {
    //         required: true,
    //         message: "请选择供应商",
    //         trigger: "change",
    //     },
    // ],
};
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    getCurrentInstance, nextTick,
} from "vue";
import {
    getManagementTable,
    getOrderCarOrderinfo,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList,
    getCarBrand,
    getConstructors,
    getWorkSettlementInfo,
    getCarOne,
    getPayQrcode,
    orderAdvancePayment,
    getBasicsetList,
    purchaseCopeExport,
    workSettlementExport,
    orderAdvancePaymentList,
    permissionList,
    getSupplierList,
    postDelothercosts,
    getOthercostsList,
    postAddothercosts,
    getAllPartnerList,
    getSupplierTotalList,
    getBasicsetTotalList,
    workSettlementFade,
    changeFadeOrder,
    createFadeOrder, getFadeOrderDetail, getIncomePrice, editCarInfoDetail
} from "@/api/http";
import {Request} from '@/api/request';
import {validateInput, validateClass} from "@/assets/js/formRules";
import {partsFormType} from "@/assets/types/common";
import {useRouter} from "vue-router";

export default defineComponent({
    name: "fadeList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["B单列表"]);
        const headClass = inject("headClass");
        //修改功能
        let editCarData = reactive({
                dialog_show: false,
                rules: {},
                form: {
                    create_time: "",
                    settlement_time: "",
                    create_time_text: "",
                    settlement_time_text: "",
                },
                formRef: null,
            });
        let userInfo = ref({} as any);
        //结算类别
        let settleData = reactive({
            settlement_class:0
        });
        //工单预收款专区
        let prepareData = reactive({
            prepareLoading:true,
            prepareList:[]
        });
        let getPrepareList = (()=>{
            orderAdvancePaymentList({order_id:currentOrder.value}).then((res:any)=>{
                prepareData.prepareLoading = false;
                prepareData.prepareList = res.content.list;
            });
        });
        //其他成本
        let roleList = ref({} as any);
        let addCostFormRef = ref(null);
        const router = useRouter();
        
        let pageSize = ref(10),
            currentPage = ref(1),
            select_order_id = ref(0),
            dialog_search = ref('' as string),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            orderId = ref(0),
            loading = ref(true),
            payTypeArray = reactive({
                zf: []
            }),
            isPrint = ref(false),
            isProject = ref(false),
            isMountings = ref(false),
            qrcodeImgeUrl = ref(''),
            publicImgeUrl = ref(''),
            orderDetail = ref({} as any),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search: ''
            }),
            select = reactive({
                mountings_ptype_data: [],
                mountings_type_data: [],
                reappearance_type_data: [],
                mountings_brand_data: [],
                mountings_unit_data: [],
                receive_data: [],
                branch_data: [],
                supplier_data: [],
            }),
            remote_loading = ref(false),
            screenParameter = ref({
                page: currentPage.value,
                pagesize: pageSize.value,
                start_date: null,
                end_date: null,
                status: null,
                date: '',
                settlement_type:'',
                work_status: null,
                basicset_id: null,
                cicompany_id: null,
                units_id: null,
                partner_id: null,
                meet_vehicle_id: null,
                car_brand_id: null,
                car_series_id: null,
                search: null
            } as any),
            dialog_show = ref(false),
            fadeDia_show = ref(false),
            dialog_title = ref("结算工单"),
            dialogFormVisible = ref(false),
            detailTable = ref([] as Array<any>),
            currentOrder = ref(0),
            getFirstNowLastDay = (): number => {
                let now = new Date();
                let strLink = "-";
                let year = now.getFullYear();
                let month: any = now.getMonth() + 1;
                let day: any = now.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 1 && day <= 9) {
                    day = "0" + day;
                }
                let firstDate: string = year + strLink + month + strLink + '01';
                let currentDate = year + strLink + month + strLink + day;
                //var lastDay = this.getLastDay(year, month);
                //var lastDate = year + strLink + month + strLink + lastDay;
                return new Date(currentDate).getTime();
            },
            carInfoTable = ref([] as Array<any>),
            carInfoDia_show = ref(false),
            preparePayDia_show = ref(false),
            preparePayForm = reactive({
                time: getFirstNowLastDay(),
                income_collection: '',
                payTypeOne: '',
                payTypeTwo: '',
                priceOne: '',
                priceTwo: '',
                desc: ''
            }),
            settle_show = ref(false),
            settle_title = ref("1111"),
            formRef = ref(null),
            form = ref({
                date_type: null,
                name: "",
                mountings_type_pid: null,
                mountings_type_id: null,
                cost_price: null,
                selling_price: null,
                price_lock: 1,
                mountings_brand_id: null,
                specification: "",
                encoding: null,
                unit_id: null,
                build_bonus_type: 1,
                build_bonus_price: null,
                sell_bonus_type: 1,
                use_balance: 0,
                sell_bonus_price: null,
                return_cash_plan: null,
                describe: ""
            }),
            return_price_rules = reactive({
                settlement_type: [{required: true, message: '必填', trigger: 'trigger'}],
                price: [{required: true, message: '必填', trigger: 'trigger'}]
            }),
            return_price_ref = ref(null),
            return_price_form_data = ref({
                order_id: '',
                settlement_type: '',
                price: '',
                return_price_notes: ''
            }),
            form_load = ref(false),
            form_rules = reactive({
                // settlement_type: [{required: true, message:'必填', trigger: 'trigger'}],
                // price: [{required: true, message:'必填', trigger: 'trigger'}],
            }),
            selectList = ref({} as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                cost_price: [{required: true, message: '必填', trigger: "change"}],
                mountings_type_pid: [{required: true, message: '必填', trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            }),
            dialog_data = ref([] as Array<any>),
            dialog_isload = ref(false),
            
            // 打印的表单
            printData = {
                id: "#print",
                popTitle: "车辆维修工时配件结算清单",
                startCallback() {
                },
            };
        let handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            createOrder = (()=>{
                fadeDia_show.value = true;
                get_dialog_data();
            }),
            get_dialog_data = () => {
        
                dialog_isload.value = true
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/carcodeGetList',
                    data: {car_code: dialog_search.value}
                }).then((res: any) => {
                    dialog_isload.value = false
                    dialog_data.value = res?.content?.list || []
                })
        
            },
            _table_select_carcode = (selection: any) => {
                if (!selection) return
                fadeDia_show.value = false;
                createFadeOrder({order_id:selection.id}).then(()=>{
                    getTableData();
                });
            },
            getTableData = (): void => {
                console.log({...screenParameter, page: currentPage.value})
                loading.value = true;
                let data = {
                    type:1,
                    role_name:'settlement',
                }
                permissionList(data).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                workSettlementFade({...screenParameter.value, page: currentPage.value,pagesize:pageSize.value}).then((res:any)=>{
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                
                workSettlementExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(() => {
                    loading.close();
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(select, res?.content || {});
                    remote_loading.value = false;
                });
                getConstructors({}).then((res: any) => {
                    select.branch_data = res?.content?.branch || [];
                    console.log(select.branch_data)
                    // select.receive_data = res?.content?.staff || [];
                    // constructors_data.value = [{id:1,name:'部门',children:select.branch_data},{id:2,name:"个人",children:select.receive_data}];
                });
            },
//车辆信息
            getCarInfo = () => {
                getCarOne({
                    car_id: orderDetail.value.car_id
                }).then((res: any) => {
                    if (res.status == 200) {
                        carInfoDia_show.value = true;
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                'VIN',
                                info.vin,
                                '品牌车型',
                                info.model_name,
                                '所属单位',
                                info.repairunit,
                                '车身颜色',
                                info.body_color,
                            ], [
                                '车主姓名',
                                info.master_name,
                                '车主手机',
                                info.car_master_phone,
                                '车主身份证',
                                info.idcard,
                                '发动机号',
                                info.engine_number,
                            ], [
                                '下次保养',
                                info.nm_time_text,
                                '保养里程',
                                info.maintenance_mileage,
                                '年检到期',
                                info.aidue_text,
                                '购车时间',
                                info.purchase_time_text,
                            ], [
                                '商业险到期',
                                info.ccidue_text,
                                '交强险到期',
                                info.compulsory_insurance_due_text,
                                '商业险公司',
                                info.cicompany_name,
                                '交强险公司',
                                info.jiompany_name,
                            ], [
                                '商业险保单号',
                                info.cipnumber,
                                '交强险保单号',
                                info.dipolicy_no,
                                '接车提示',
                                info.tips,
                            ]];
                            carInfoTable.value = arr;
                        }
                    }
                });
            },
            //验证收款方式
            checkPrepare = (): boolean => {
                if (!preparePayForm.priceOne && !preparePayForm.priceTwo) {
                    alert("收款金额必须大于0");
                    return false
                }
                if (preparePayForm.priceOne && (Number(preparePayForm.priceOne) <= 0)) {
                    alert("金额必须为大于0的数字");
                    return false
                }
                if (preparePayForm.priceTwo && (Number(preparePayForm.priceTwo) <= 0)) {
                    alert("金额必须为大于0的数字");
                    return false
                }
                if (preparePayForm.priceOne && !preparePayForm.payTypeOne) {
                    alert("请选择第一种收款方式");
                    return false
                }
                if (preparePayForm.priceTwo && !preparePayForm.payTypeTwo) {
                    alert("请选择第二种收款方式");
                    return false
                }
                return true
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({search: e});
            },
            formSelectChange = (e: number) => {
                getSelectData({type_pid: e});
                form.value.mountings_type_id = null;
            },
            //工单确认结算的时候直接减免输入的逻辑判断
            reductionChange = (e: number): void => {
                (form.value as any)['discount_price'] = e;
                console.log(e);
                nextTick(() => {
                    // 减免要计算报价金额为最大减免（因为超过报价金额且存在预收款时，需要预收退款；存在余额时，则需要隐藏余额抵扣）
                    let newValue=0;
                    if (e>Number((form.value as any)['order_offer_price'])){
                        newValue = Number((form.value as any)['order_offer_price']);
                    }else{
                        newValue = e;
                    }
                    (form.value as any)['discount_price'] = newValue;
                    let subPrice = (form.value as any)['order_offer_price'] - (form.value as any)['discount_price']-(form.value as any)['order_advance_payment_text'];
                    if(subPrice<0){
                        //说明要退款
                        (form.value as any)['refund_price'] = Math.abs(subPrice);
                        (form.value as any)['price'] = 0;
                    }else{
                        (form.value as any)['refund_price'] = 0;
                        (form.value as any)['price'] = subPrice;
                    }
                    // 改变减免金额时，将余额抵扣重置为0，避免计算出错，回头改减免就需要重新让用户输要抵扣多少余额
                    (form.value as any)['use_balance'] = 0;
                });
                
            },
            balanceChange = (e:number): void  => {
                // 余额抵扣要计算剩余可抵扣的金额（由于预收款超过结算金额时，余额抵扣会被隐藏，所以不用在这里处理负数的问题了）
                let use_balance = Math.min(e, (form.value as any)['order_offer_price'] - (form.value as any)['discount_price']-(form.value as any)['order_advance_payment_text']);
                (form.value as any)['use_balance'] = use_balance;
                let subPrice = (form.value as any)['order_offer_price'] - (form.value as any)['discount_price']-(form.value as any)['order_advance_payment_text']-(form.value as any)['use_balance'];
                (form.value as any)['price'] = subPrice;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            // 点击单据编号触发
            getOrderCarinfo = (order_id: number) => {
                currentOrder.value = order_id;
                getFadeOrderDetail({order_id: order_id}).then((res: any) => {
                    if (res.status == 200) {
                        dialogFormVisible.value = true;
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.ordersn,
                                '状态',
                                info.orderstatustext,
                                '开单时间',
                                info.create_time_text,
                                '结算时间',
                                info.settlement_time_text,
                            ], [
                                '服务类型',
                                info.basicset_id_name,
                                '接车人',
                                info.meet_vehicle_id_name,
                                '报价金额',
                                info.offer_price,
                                '结算金额',
                                info.settlement_pirce,
                            ], [
                                '车牌号码',
                                info.car_code,
                                '品牌车型',
                                info.series_name,
                                '进厂里程',
                                info.mitplant,
                                '是否返修',
                                info.is_rework_text,
                            ], [
                                '送修人',
                                info.send_for_repair,
                                '手机号码',
                                info.send_for_repair_phone,
                                '会员号',
                                info.user_id,
                                '昵称',
                                info.user_nickname,
                            ], [
                                '保险公司',
                                info.cicompany_id_name,
                                '送修单位',
                                info.units_id_name,
                                '合作方',
                                info.partner_id_name,
                                '工单备注',
                                info.settlement_notes,
                            ]];
                            detailTable.value = arr;
                            orderDetail.value = res.content.list;
                            if (res.content.list.order_offer_project.length > 0) {
                                isProject.value = true
                                console.log(orderDetail.value);
                            }
                            if (res.content.list.order_offer_mountings.length > 0) {
                                isMountings.value = true
                            }
                        }
                    }
                });
            },
            resetTableData = (()=>{
                currentPage.value = 1;
                getTableData();
            }) ,
            //筛选条件
            screenChange = (e: any, key: string): void => {
                if (key == "date") {//Math.floor
                    if (e){
                        screenParameter.value.start_date = Math.floor(new Date(e[0]).getTime()/1000);
                        screenParameter.value.end_date = Math.floor(new Date(e[1]).getTime()/1000);
                    }else{
                        screenParameter.value.start_date = 0;
                        screenParameter.value.end_date = 0;
                    }
                    
                } else if (key == 'search') {
                    screenParameter.value.search = e as string;
                } else if (key == 'select_brand') {
                    
                    if (screenParameter.value.car_brand_id != 0) {
                        Request.axiosInstance({
                            url: "adminapi/MobileOrder/carBrand",
                            data: {
                                brand_id: screenParameter.value.car_brand_id
                            }
                        }).then((res: any) => {
                            selectList.value.carseriesList = res?.content?.list || []
                        })
                        return
                    } else {
                        screenParameter.value.car_series_id = null
                        selectList.value.carseriesList = []
                    }
                    
                    
                }
                
                //getTableData();
                resetTableData();
            },
            columnChange = (item: any,flag:number): void => {
                switch (flag){
                    case 1:
                        router.push({
                            path: "/cashRegister/fadeList/fadeBillDetail",
                            query: {
                                id: item.order_id,
                                orderStatus:item.orderstatus
                            },
                        });
                        break;
                        case 2:
                            ElMessageBox.prompt('收款金额', '', {
                                confirmButtonText: '确认',
                                cancelButtonText: '取消',
                            })
                                .then(({ value }) => {
                                    getIncomePrice({price:value,order_id:item.order_id}).then(()=>{
                                    
                                    });
                                })
                                .catch(() => {
                                
                                })
                            break;
                            case 3:
                                editCarData.dialog_show = true;
                                select_order_id.value = item.order_id;
                                break;
                }
            },
            //提交回款
            _submitSettle = () => {
                (return_price_ref.value as any).validate((valid: boolean) => {
                    if (!valid) {
                        console.log('停止了');
                        return
                    } else {
                        settle_show.value = false;
                        let data = {
                            order_id: return_price_form_data.value.order_id,
                            settlement_type: return_price_form_data.value.settlement_type,
                            price: return_price_form_data.value.price,
                            desc: return_price_form_data.value.return_price_notes,
                        };
                        Request.axiosInstance({
                            url: "adminapi/order/returnPrice",
                            data
                        }).then(() => {
                            getTableData()
                        })
                    }
                });
            },
            //提交结算确认和结算
            _submitForm = () => {
                console.log(form.value);
                if (dialog_title.value == '结算') {
                    if (!(form.value as any)['is_hang_']) {
                        if (!(form.value as any)['settlement_type']) {
                            alert('请选择收款方式');
                            return
                        }
                        if (Number((form.value as any)['payment_price']) > Number((form.value as any)['price'])) {
                            alert('收款金额不能大于应收金额');
                            return
                        }
                    }
                    
                }
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid) return
                    Request.axiosInstance({
                        url: dialog_title.value == '结算' ? 'adminapi/order/settlementV2' : 'adminapi/order/confirmSettlementV2',
                        data: (
                            dialog_title.value == '结算' ?
                                {...form.value, is_hang: (form.value as any)['is_hang_'] ? 1 : 0}
                                : {...form.value,settlement_class:settleData.settlement_class}
                        )
                    }).then((res: any) => {
                        if (res.status == '202') {
                            dialog_show.value = false
                            getTableData()
                        }
                    })
                    
                    
                    //dialogFormVisible.value = !valid;
                });
            },
            resettlement = (id: number) => {
                if (!confirm("是否确认反结算？反结算后，减免金额、收入记账记录、业绩成本数据将会被销毁，请谨慎操作")) return;
                Request.axiosInstance({
                    url: "adminapi/order/reverseSettlement",
                    data: {order_id: id}
                }).then(() => {
                    getTableData()
                })
                
            },
            _returnPrice = (id: number) => {
                // if (!confirm("是否确认？")) return;
                // Request.axiosInstance({
                //   url: "adminapi/order/returnPrice",
                //   data: {order_id: id}
                // }).then(() => {
                //   getTableData()
                // })
                
                if(return_price_ref.value){
                    (return_price_ref.value as any).resetFields();
                }
                settle_show.value = true
                settle_title.value = '回款'
                Promise.all([
                    workSettlementInfo(id),
                    Request.axiosInstance({url: "adminapi/order/collection"})
                ]).then((res: any) => {
                    selectList.value['collection'] = res[1]?.content?.list
                })
                
            },
            _badDebt = (id: number) => {
                if (!confirm("是否确认？")) return;
                Request.axiosInstance({
                    url: "adminapi/order/badDebt",
                    data: {order_id: id}
                }).then(() => {
                    getTableData()
                })
                
            },
            //工单结算
            _settlement = (id: number) => {
                dialog_show.value = true
                dialog_title.value = '结算'
                
                Promise.all([
                    workSettlementInfo(id),
                    Request.axiosInstance({url: "adminapi/order/collection"})
                ])
                    .then((res: any) => {
                        selectList.value['collection'] = res[1]?.content?.list
                    })
            },
            //工单结算确认
            _confirmSettlement = (id: number) => {
                settleData.settlement_class = 0;
                dialog_show.value = true
                dialog_title.value = '工单结算'
                workSettlementInfo(id).then((res: any) => {
                
                })
            },
            //获取工单结算信息
            workSettlementInfo = (id: number) => {
                form_load.value = true
                return Request.axiosInstance({
                    url: "adminapi/order/workSettlementInfoV2",
                    data: {order_id: id}
                }).then((res: any) => {
                    form.value = {
                        ...res?.content?.list,
                        is_hang_: false,
                        settlement_type: null,
                        // 默认获取报价金额为结算金额，用于金额动态结算
                        //price: res?.content?.list.order_offer_price,
                        payment_price:'0.00'
                    }
                    // return_price_form_data.value = {
                    //     ...res?.content?.list
                    // }
                    return_price_form_data.value.order_id = res.content.list.order_id;
                    return_price_form_data.value.price = res.content.list.return_price;
                    form_load.value = false
                })
            },
            // 触发打印
            bindPrint = (order_id: number): void => {
                orderId.value = order_id;
                // 获取支付二维码
                // getPayQrcode({order_id}).then((res: any) => {
                //     if (res.status == 200) {
                //         qrcodeImgeUrl.value = res.content.qrcode_image;
                //         publicImgeUrl.value = res.content.gong_image;
                //     }
                // });
                // 列表打印按钮是没有请求订单信息的，需要单独请求
                getFadeOrderDetail({order_id}).then((res: any) => {
                    console.log(res)
                    if (res.status == 200) {
                        if (res.content.list) {
                            orderDetail.value = res.content.list;
                            if (res.content.list.order_offer_project.length > 0) {
                                isProject.value = true
                            }
                            if (res.content.list.order_offer_mountings.length > 0) {
                                isMountings.value = true
                            }
                            document.getElementById("printBtn")!.click();
                            isPrint.value = true;
                            setTimeout(() => {
                                isPrint.value = false;
                                console.log(isPrint.value)
                            }, 1)
                        }
                    }
                });
            },
            saveCarInfoChange = (e: any, key: string) => {
                if (key == "create_time" || key == "settlement_time") {
                    console.log(e);
                    if (e) {
                        e = new Date(e).getTime() / 1000;
                        console.log(e);
                        editCarData.form[key] = e;
                    } else {
                        editCarData.form[key] = "";
                    }
                
                }
            },
            saveSubmit = (() => {
                changeFadeOrder({order_id:select_order_id.value,...editCarData.form}).then(()=>{
                    editCarData.dialog_show = false;
                    getTableData();
                });
            }),
            getSummaries = (param: any, type: number): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = orderDetail.value.project_sum_quoted_price;
                                } else {
                                    sums[index] = orderDetail.value.project_sum_output_value;
                                }
                                break;
                            // 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = orderDetail.value.mountings_sum_output_value;
                                } else {
                                    sums[index] = orderDetail.value.mountings_sum_quoted_price;
                                }
                                
                                break;
                            // 配件成本合计
                            case 3:
                                sums[index] = orderDetail.value.mountings_cost_price;
                                break;
                            // 其他成本合计
                            case 4:
                                sums[index] = orderDetail.value.else_cost_price;
                                break;
                            // 工单结算合计
                            case 5:
                                sums[index] = orderDetail.value.settlement_pirce;
                                break;
                        }
                        // sums[index] = values.reduce((prev: any, curr: any) => {
                        //     const value = Number(curr);
                        //     if (!isNaN(value)) {
                        //         return prev + curr;
                        //     } else {
                        //         return prev;
                        //     }
                        // }, 0);
                        sums[index] = `¥${sums[index]}`;
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            handleClose = (): void => {
                isPrint.value = false;
            }
        
        
        onMounted(() => {
            let user_info = localStorage.getItem('user_info')
            if(user_info){
                userInfo.value = JSON.parse(user_info)
            }
            getTableData();
            getSelectData({});
            getBasicsetTotalList({
                basicset_type: 3
            }).then((res: any) => {
                payTypeArray.zf = res.content?.list;
            });
            getAllPartnerList({}).then((res:any)=>{
                selectList.value.partner_data = res?.content?.list || [];
            });
            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/MobileOrder/get'
                }),
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/repairunit'
                }),
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/constructors'
                }),
                getCarBrand({})
            ]).then((res: any) => {
                selectList.value = {
                    ...(res[0]?.content),
                    unitList: res[1]?.content?.list,
                    staffList: res[2]?.content?.staff,
                    carbrandList: res[3]?.content?.list,
                    carseriesList: []
                }
            })
        });
        
        return {
            columnList,
            saveSubmit,
            saveCarInfoChange,
            headClass,
            userInfo,
            pageSize,
            currentPage,
            tableData,
            bindPrint,
            handleClose,
            orderId,
            orderDetail,
            qrcodeImgeUrl,
            publicImgeUrl,
            printData,
            isPrint,
            isProject,
            isMountings,
            total,
            loading,
            selectGroup,
            select,
            remote_loading,
            dialog_show,
            dialog_title,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            remoteBrand,
            balanceChange,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            _submitForm,
            selectList,
            screenParameter,
            screenChange,
            resettlement,
            _returnPrice,
            _badDebt,
            _settlement,
            _confirmSettlement,
            workSettlementInfo,
            reductionChange,
            form_load,
            form_rules,
            settle_show,
            settle_title,
            _submitSettle,
            return_price_rules,
            return_price_ref,
            return_price_form_data,
            dialogFormVisible,
            detailTable,
            getOrderCarinfo,
            getSummaries,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn,
            preparePayDia_show,
            preparePayForm,
            carInfoDia_show,
            getCarInfo,
            carInfoTable,
            payTypeArray,
            exportChange,
            settlementType,
            prepareData,
            settleData,
            roleList,
            elseCostListColumn,
            costRules,
            addCostFormRef,
            currentOrder,
            createOrder,
            dialog_search,
            get_dialog_data,
            dialog_data,
            dialog_isload,
            _table_select_carcode,
            fadeDia_show,
            editCarData
        };
    },
});
